/**
 * Model-only frame directives for a typed screen or webcam question on Live.
 * The composer puts one in front of the typed line so the model reads the right frame.
 * The gateway stores the whole line as the canonical user turn, so the projection
 * must drop the directive before it renders a YOU row.
 */
export const LIVE_SCREEN_FRAME_DIRECTIVE =
  'Use only the current screen-share frame for this answer. Ignore webcam frames unless the user explicitly asks about the webcam. Do not ask business discovery, sales, goals, or follow-up questions. Answer only what the verified frame shows.'

export const LIVE_WEBCAM_FRAME_DIRECTIVE =
  'Use only the current webcam frame for this answer. Ignore screen-share frames unless the user explicitly asks about the screen. Do not ask business discovery, sales, goals, or follow-up questions. Answer only what the verified frame shows.'

const DIRECTIVES = [LIVE_SCREEN_FRAME_DIRECTIVE, LIVE_WEBCAM_FRAME_DIRECTIVE]

/** Remove a frame directive and its separator. The composer joins with a literal "\n\n". */
export function stripLiveVisualDirective(text: string): string {
  if (!text) return text
  let next = text
  let changed = false
  for (const directive of DIRECTIVES) {
    if (!next.includes(directive)) continue
    changed = true
    next = next.split(directive).join('')
  }
  if (!changed) return text
  return next.replace(/^(?:\s|\\n)+/, '').replace(/(?:\s|\\n)+$/, '').trim()
}
